/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      fname
      Position
      location
      mname
      lname
      role
      division
      status
      username
      signatureLoc
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        fname
        Position
        location
        mname
        lname
        role
        division
        status
        username
        signatureLoc
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getLOI = /* GraphQL */ `
  query GetLOI($id: ID!) {
    getLOI(id: $id) {
      id
      instruction_title
      ownedBy
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listLOIs = /* GraphQL */ `
  query ListLOIs(
    $filter: ModelLOIFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLOIs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        instruction_title
        ownedBy
        division
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getCOI = /* GraphQL */ `
  query GetCOI($id: ID!) {
    getCOI(id: $id) {
      id
      application
      applicant_email
      application_name
      application_status
      building_professional
      building_professionals_email
      instruction_title
      instruction_list
      instructionlist1
      loi_category
      ownedBy
      division
      oic_city_building_official
      site_inspector_technical_evaluator
      section_chief
      chief_final_permits
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listCOIs = /* GraphQL */ `
  query ListCOIs(
    $filter: ModelCOIFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCOIs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        application
        applicant_email
        application_name
        application_status
        building_professional
        building_professionals_email
        instruction_title
        instruction_list
        instructionlist1
        loi_category
        ownedBy
        division
        oic_city_building_official
        site_inspector_technical_evaluator
        section_chief
        chief_final_permits
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getActionTaken = /* GraphQL */ `
  query GetActionTaken($id: ID!) {
    getActionTaken(id: $id) {
      id
      action_taken
      ownedBy
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listActionTakens = /* GraphQL */ `
  query ListActionTakens(
    $filter: ModelActionTakenFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActionTakens(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        action_taken
        ownedBy
        division
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getBasic = /* GraphQL */ `
  query GetBasic($id: ID!) {
    getBasic(id: $id) {
      id
      basic
      ownedBy
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listBasics = /* GraphQL */ `
  query ListBasics(
    $filter: ModelBasicFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBasics(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        basic
        ownedBy
        division
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getPayitem = /* GraphQL */ `
  query GetPayitem($id: ID!) {
    getPayitem(id: $id) {
      id
      payitem_details
      ownedBy
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listPayitems = /* GraphQL */ `
  query ListPayitems(
    $filter: ModelPayitemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPayitems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        payitem_details
        ownedBy
        division
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getCreateOrderOfPayment = /* GraphQL */ `
  query GetCreateOrderOfPayment($id: ID!) {
    getCreateOrderOfPayment(id: $id) {
      id
      order_payment_no
      name_of_applicant
      project_location
      project_name
      control_no
      notice_of_payment_no
      application_no
      order_of_payment_details
      listOfInspector
      attachementFile
      grand_total_payment_no
      signature1
      floorArea
      signature2
      nameofsignature1
      nameofsignature2
      opStatus
      applicant_email
      billing_officer
      billing_officer_signature
      inspection_report
      ORNumber
      disapproved
      forwardDate
      approved1Date
      approved2Date
      PostFlag
      remarks
      OrDate
      isDeleted
      ownedBy
      createdAt
      division
      updatedAt
      owner
    }
  }
`;
export const listCreateOrderOfPayments = /* GraphQL */ `
  query ListCreateOrderOfPayments(
    $filter: ModelCreateOrderOfPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCreateOrderOfPayments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        order_payment_no
        name_of_applicant
        project_location
        project_name
        control_no
        notice_of_payment_no
        application_no
        order_of_payment_details
        listOfInspector
        attachementFile
        grand_total_payment_no
        signature1
        floorArea
        signature2
        nameofsignature1
        nameofsignature2
        opStatus
        applicant_email
        billing_officer
        billing_officer_signature
        inspection_report
        ORNumber
        disapproved
        forwardDate
        approved1Date
        approved2Date
        PostFlag
        remarks
        OrDate
        isDeleted
        ownedBy
        createdAt
        division
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getCreateOrderOfBilling = /* GraphQL */ `
  query GetCreateOrderOfBilling($id: ID!) {
    getCreateOrderOfBilling(id: $id) {
      id
      typeofapplication
      application_no
      owner
      occupancy
      project_activity
      Payitem
      locations
      Signature1
      Signature2
      opStatus
      status
      signatureDate1
      signatureDate2
      opStatusDate1
      order_payment_no
      billing_officer
      nameofapprover4
      nameofapprover5
      adminUserName
      dateAdminUpdate
      oic_zoning_administrator
      application_type
      OrNumber
      OrDate
      grandTotal
      lot_no
      blk_no
      location_street
      location_barangay
      location_district
      zone_classification
      lot_area
      floor_area
      no_of_units
      tct_no
      evaluation_facts
      evaluation_facts_extended
      lcNo
      ceNo
      isGovementInstitution
      isCleared
      doesHaveOldOP
      isNoPaymenItem
      isClearedDate
      postalAddress
      counselResolutionNo
      counselResolutionDate
      deniedRemarks
      deniedDate
      isDeny
      isDeleted
      address
      isDeletedDate
      whyDeletedRemarks
      ownedBy
      division
      createdAt
      updatedAt
    }
  }
`;
export const listCreateOrderOfBillings = /* GraphQL */ `
  query ListCreateOrderOfBillings(
    $filter: ModelCreateOrderOfBillingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCreateOrderOfBillings(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        typeofapplication
        application_no
        owner
        occupancy
        project_activity
        Payitem
        locations
        Signature1
        Signature2
        opStatus
        status
        signatureDate1
        signatureDate2
        opStatusDate1
        order_payment_no
        billing_officer
        nameofapprover4
        nameofapprover5
        adminUserName
        dateAdminUpdate
        oic_zoning_administrator
        application_type
        OrNumber
        OrDate
        grandTotal
        lot_no
        blk_no
        location_street
        location_barangay
        location_district
        zone_classification
        lot_area
        floor_area
        no_of_units
        tct_no
        evaluation_facts
        evaluation_facts_extended
        lcNo
        ceNo
        isGovementInstitution
        isCleared
        doesHaveOldOP
        isNoPaymenItem
        isClearedDate
        postalAddress
        counselResolutionNo
        counselResolutionDate
        deniedRemarks
        deniedDate
        isDeny
        isDeleted
        address
        isDeletedDate
        whyDeletedRemarks
        ownedBy
        division
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getBackupcreateorderofpayment = /* GraphQL */ `
  query GetBackupcreateorderofpayment($id: ID!) {
    getBackupcreateorderofpayment(id: $id) {
      id
      order_payment_no
      name_of_applicant
      project_location
      project_name
      control_no
      notice_of_payment_no
      application_no
      order_of_payment_details
      listOfInspector
      grand_total_payment_no
      signature1
      signature2
      nameofsignature1
      nameofsignature2
      opStatus
      applicant_email
      billing_officer
      billing_officer_signature
      PostFlag
      ORNumber
      OrDate
      ownedBy
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listBackupcreateorderofpayments = /* GraphQL */ `
  query ListBackupcreateorderofpayments(
    $filter: ModelbackupcreateorderofpaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBackupcreateorderofpayments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        order_payment_no
        name_of_applicant
        project_location
        project_name
        control_no
        notice_of_payment_no
        application_no
        order_of_payment_details
        listOfInspector
        grand_total_payment_no
        signature1
        signature2
        nameofsignature1
        nameofsignature2
        opStatus
        applicant_email
        billing_officer
        billing_officer_signature
        PostFlag
        ORNumber
        OrDate
        ownedBy
        division
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getBuildingandlocationalDB = /* GraphQL */ `
  query GetBuildingandlocationalDB($id: ID!) {
    getBuildingandlocationalDB(id: $id) {
      id
      order_payment_no
      name_of_applicant
      project_location
      project_name
      control_no
      notice_of_payment_no
      application_no
      order_of_payment_details
      listOfInspector
      grand_total_payment_no
      signature1
      signature2
      nameofsignature1
      nameofsignature2
      opStatus
      applicant_email
      billing_officer
      billing_officer_signature
      inspection_report
      ORNumber
      OrDate
      ownedBy
      permit_application_type
      permit_type
      processing_for_divsion
      recommendingapproval
      endorseApproval
      recommendingapprovalPosition
      locational_clearance_no
      disapproved
      floorArea
      billofmaterials
      total_zoning
      total_dbo
      total_quality_zoning
      total_quality_dbo
      in_charge_of_construction
      profession
      prc_no_validity
      ptr_no_validity
      remarks
      locations
      genderType
      createdAt
      division
      updatedAt
      owner
    }
  }
`;
export const listBuildingandlocationalDBs = /* GraphQL */ `
  query ListBuildingandlocationalDBs(
    $filter: ModelbuildingandlocationalDBFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBuildingandlocationalDBs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        order_payment_no
        name_of_applicant
        project_location
        project_name
        control_no
        notice_of_payment_no
        application_no
        order_of_payment_details
        listOfInspector
        grand_total_payment_no
        signature1
        signature2
        nameofsignature1
        nameofsignature2
        opStatus
        applicant_email
        billing_officer
        billing_officer_signature
        inspection_report
        ORNumber
        OrDate
        ownedBy
        permit_application_type
        permit_type
        processing_for_divsion
        recommendingapproval
        endorseApproval
        recommendingapprovalPosition
        locational_clearance_no
        disapproved
        floorArea
        billofmaterials
        total_zoning
        total_dbo
        total_quality_zoning
        total_quality_dbo
        in_charge_of_construction
        profession
        prc_no_validity
        ptr_no_validity
        remarks
        locations
        genderType
        createdAt
        division
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getLogs = /* GraphQL */ `
  query GetLogs($id: ID!) {
    getLogs(id: $id) {
      id
      transactionId
      ownedBy
      details
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listLogss = /* GraphQL */ `
  query ListLogss(
    $filter: ModellogsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLogss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        transactionId
        ownedBy
        details
        division
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getRecommendingapproval = /* GraphQL */ `
  query GetRecommendingapproval($id: ID!) {
    getRecommendingapproval(id: $id) {
      id
      recommendingApprovalSignature
      nameofrecommendingApproval
      position
      ownedBy
      details
      division
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listRecommendingapprovals = /* GraphQL */ `
  query ListRecommendingapprovals(
    $filter: ModelrecommendingapprovalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRecommendingapprovals(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        recommendingApprovalSignature
        nameofrecommendingApproval
        position
        ownedBy
        details
        division
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getTblLoiGenerator = /* GraphQL */ `
  query GetTblLoiGenerator($id: ID!) {
    getTblLoiGenerator(id: $id) {
      id
      reference_no
      loiFor
      section_chief
      chief_division
      recommendingApproval
      loi
      loi_instructions
      evaluator
      referencesDetails
      recommendation
      evaluator_status
      section_chief_status
      chief_division_status
      evaluationResult
      EvaluatorStatus
      createdAt
      ownedBy
      division
      updatedAt
      owner
    }
  }
`;
export const listTblLoiGenerators = /* GraphQL */ `
  query ListTblLoiGenerators(
    $filter: ModeltblLoiGeneratorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTblLoiGenerators(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reference_no
        loiFor
        section_chief
        chief_division
        recommendingApproval
        loi
        loi_instructions
        evaluator
        referencesDetails
        recommendation
        evaluator_status
        section_chief_status
        chief_division_status
        evaluationResult
        EvaluatorStatus
        createdAt
        ownedBy
        division
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const createOrderOfPaymentByOP = /* GraphQL */ `
  query CreateOrderOfPaymentByOP(
    $order_payment_no: String
    $sortDirection: ModelSortDirection
    $filter: ModelCreateOrderOfPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    CreateOrderOfPaymentByOP(
      order_payment_no: $order_payment_no
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        order_payment_no
        name_of_applicant
        project_location
        project_name
        control_no
        notice_of_payment_no
        application_no
        order_of_payment_details
        listOfInspector
        attachementFile
        grand_total_payment_no
        signature1
        floorArea
        signature2
        nameofsignature1
        nameofsignature2
        opStatus
        applicant_email
        billing_officer
        billing_officer_signature
        inspection_report
        ORNumber
        disapproved
        forwardDate
        approved1Date
        approved2Date
        PostFlag
        remarks
        OrDate
        isDeleted
        ownedBy
        createdAt
        division
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const createOrderOfPaymentByOPByOwnedBy = /* GraphQL */ `
  query CreateOrderOfPaymentByOPByOwnedBy(
    $ownedBy: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCreateOrderOfPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    CreateOrderOfPaymentByOPByOwnedBy(
      ownedBy: $ownedBy
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        order_payment_no
        name_of_applicant
        project_location
        project_name
        control_no
        notice_of_payment_no
        application_no
        order_of_payment_details
        listOfInspector
        attachementFile
        grand_total_payment_no
        signature1
        floorArea
        signature2
        nameofsignature1
        nameofsignature2
        opStatus
        applicant_email
        billing_officer
        billing_officer_signature
        inspection_report
        ORNumber
        disapproved
        forwardDate
        approved1Date
        approved2Date
        PostFlag
        remarks
        OrDate
        isDeleted
        ownedBy
        createdAt
        division
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const buildingandLocationalOp = /* GraphQL */ `
  query BuildingandLocationalOp(
    $order_payment_no: String
    $ownedBy: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelbuildingandlocationalDBFilterInput
    $limit: Int
    $nextToken: String
  ) {
    buildingandLocationalOp(
      order_payment_no: $order_payment_no
      ownedBy: $ownedBy
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        order_payment_no
        name_of_applicant
        project_location
        project_name
        control_no
        notice_of_payment_no
        application_no
        order_of_payment_details
        listOfInspector
        grand_total_payment_no
        signature1
        signature2
        nameofsignature1
        nameofsignature2
        opStatus
        applicant_email
        billing_officer
        billing_officer_signature
        inspection_report
        ORNumber
        OrDate
        ownedBy
        permit_application_type
        permit_type
        processing_for_divsion
        recommendingapproval
        endorseApproval
        recommendingapprovalPosition
        locational_clearance_no
        disapproved
        floorArea
        billofmaterials
        total_zoning
        total_dbo
        total_quality_zoning
        total_quality_dbo
        in_charge_of_construction
        profession
        prc_no_validity
        ptr_no_validity
        remarks
        locations
        genderType
        createdAt
        division
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const buildingandLocationalOpByOwnedBy = /* GraphQL */ `
  query BuildingandLocationalOpByOwnedBy(
    $ownedBy: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelbuildingandlocationalDBFilterInput
    $limit: Int
    $nextToken: String
  ) {
    buildingandLocationalOpByOwnedBy(
      ownedBy: $ownedBy
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        order_payment_no
        name_of_applicant
        project_location
        project_name
        control_no
        notice_of_payment_no
        application_no
        order_of_payment_details
        listOfInspector
        grand_total_payment_no
        signature1
        signature2
        nameofsignature1
        nameofsignature2
        opStatus
        applicant_email
        billing_officer
        billing_officer_signature
        inspection_report
        ORNumber
        OrDate
        ownedBy
        permit_application_type
        permit_type
        processing_for_divsion
        recommendingapproval
        endorseApproval
        recommendingapprovalPosition
        locational_clearance_no
        disapproved
        floorArea
        billofmaterials
        total_zoning
        total_dbo
        total_quality_zoning
        total_quality_dbo
        in_charge_of_construction
        profession
        prc_no_validity
        ptr_no_validity
        remarks
        locations
        genderType
        createdAt
        division
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const ownedByLoi = /* GraphQL */ `
  query OwnedByLoi(
    $ownedBy: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModeltblLoiGeneratorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    ownedByLoi(
      ownedBy: $ownedBy
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reference_no
        loiFor
        section_chief
        chief_division
        recommendingApproval
        loi
        loi_instructions
        evaluator
        referencesDetails
        recommendation
        evaluator_status
        section_chief_status
        chief_division_status
        evaluationResult
        EvaluatorStatus
        createdAt
        ownedBy
        division
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
